// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EqualwebButton_wrapper__v8x2S"};